import React from 'react';

import Card from 'components/shared/card';

import useStyles from 'isomorphic-style-loader/useStyles';
import classes from './style.module.scss';
import globalStyles from 'styles/main.scss';

export default ({ company }) => {
  useStyles(classes, globalStyles);
  
  return (
    <div className={globalStyles.textCenter}>
      <a className={classes.link} href={company.url} target='_blank' >
        <Card
          image={{ url: company.logo, title: company.name, alt: company.name, height: '150px' }}  
          customClasses={{ container: classes.cardContainer, image: classes.image }}
        />
        <span className={classes.title}>
          { company.name }
        </span>
      </a>
    </div>
  );
}